import React, { FC } from 'react'

const storeToGA4 = {
  1: 'G-X99MH137P1',
  3: 'G-FLEWY295H5',
  4: 'G-L8RGKGCQW5',
  5: 'G-5KKVPFNPGN',
  6: 'G-M9WSC5GJ0Z',
  7: 'G-25611C7P8M',
  8: 'G-64J3S0KH10',
  9: 'G-K6J1Y83DCT',
  10: 'G-1GLYMXM8HE',
  11: 'G-46LRHPSS7E',
  12: 'G-46LRHPSS7E',
  14: 'G-G8RQS6Z06Q',
  15: 'G-K33XVLH4GL',
  16: 'G-RLQGD6C8NZ',
  17: 'G-HQS180D8C1',
  18: 'G-9GPK2RMY1S',
  19: 'G-GQSWBQ4SC7',
  20: 'G-GQSWBQ4SC7',
  21: 'G-BZ5LHSZ0PV',
  22: 'G-ZG5L4D3T0N',
  23: 'G-L5QMNK2GET',
  24: 'G-CLXJJ09RXH',
  25: 'G-KP0PTXXELK',
  26: 'G-R1S2V5YJLS',
  27: 'G-YCJ3B11M83',
  28: 'G-1FV8PN97M8',
  29: 'G-36MKKSVNTY',
  32: 'G-FBTKM7EHX0',
  33: 'G-XP14NWYN46',
  34: 'G-XP14NWYN46',
  36: 'G-YCJ3B11M83',
}

interface GTagScriptProps {
  measurementID: string
  storeID: string
}

const gtagSetup = (measurementID: string, ga4ID: string) => `
function gtag(){dataLayer.push(arguments);}
gtag('consent', 'default', {
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
  analytics_storage: 'denied',
  wait_for_update: 2000
});
gtag('js', new Date());
gtag('config', '${measurementID}');
window.thGA4ID = '${ga4ID}';
if (window.thGA4ID) {
  gtag('config', '${ga4ID}');
}
`

// Used to load and setup gtag.js
export const GTagScript: FC<GTagScriptProps> = (
  {
    measurementID,
    storeID,
  }: GTagScriptProps,
) => (
  <>
    <script
      key="gtag-load"
      async
      src={`https://www.googletagmanager.com/gtag/js?id=${measurementID}`}
      type="text/javascript"
    />
    <script
      key="gtag-setup"
      dangerouslySetInnerHTML={{ __html: gtagSetup(measurementID, storeToGA4[storeID] || '') }}
      type="text/javascript"
    />
  </>
)

export const gtagEvent = (eventType: string, data: Record<string, any>) => {
  if (typeof window === 'undefined') {
    return
  }

  const { gtag, thGA4ID } = (window as any)

  if (!gtag || !thGA4ID) {
    return
  }

  gtag('event', eventType, { ...data, send_to: thGA4ID })
}
